// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-block {
    width: 406px;
    border-radius: 16px;
    background-color: #47C269;
    margin: 0 15px;
    padding: 16px;
    max-width: 60%;
    position: relative;
}

.task-info,
.task-info a {
    color: #FFFFFF;
    font-family: "Open Sans";
    font-size: 18px;
    letter-spacing: 0;
    line-height: 24px;
}

.task-info a {
    font-weight: bold;
}

.close {
    position: absolute;
    cursor: pointer;
    top: 10px;
    right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/TaskBlock/TaskBlock.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,WAAW;AACf","sourcesContent":[".task-block {\n    width: 406px;\n    border-radius: 16px;\n    background-color: #47C269;\n    margin: 0 15px;\n    padding: 16px;\n    max-width: 60%;\n    position: relative;\n}\n\n.task-info,\n.task-info a {\n    color: #FFFFFF;\n    font-family: \"Open Sans\";\n    font-size: 18px;\n    letter-spacing: 0;\n    line-height: 24px;\n}\n\n.task-info a {\n    font-weight: bold;\n}\n\n.close {\n    position: absolute;\n    cursor: pointer;\n    top: 10px;\n    right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
